<template>
  <main class="page-content">
    <PageHeading
      :buttons="buttons"
      :action="tabChange"
      :partsOfDay="partsOfDay"
      :isListView="isListView"
      :toggleView="toggleView"
      :bottomBorder="true"
    />
    <div class="epg-wrap container">
      <channel-list />
      <event-list
        :isListView="isListView"
        :partsOfDay="partsOfDay"
      />
    </div>
    <favorites-sidebar/>
  </main>
</template>

<script>
import PageHeading from 'components/PageHeading'
import EventList from './EventList'
import ChannelList from './ChannelList'
import FavoritesSidebar from 'components/FavoritesSidebar'

export default {
  name: 'Guide',
  components: {
    PageHeading,
    FavoritesSidebar,
    EventList,
    ChannelList
  },
  data: function () {
    return {
      buttons: [
        // {title: 'stb_guide_nowtv', name: 'nowtv', isActive: false},
        {title: 'stb_guide_tvchannels', name: 'guide', isActive: true},
        {title: 'stb_guide_radiostations', name: 'radio', isActive: false}
      ],
      partsOfDay: {
        morning: {
          label: 'guide_calendar_timeslot_morning',
          timeStart: '06:00',
          timeEnd: '11:59'
        },
        afternoon: {
          label: 'guide_calendar_timeslot_afternoon',
          timeStart: '12:00',
          timeEnd: '17:59'
        },
        evening: {
          label: 'guide_calendar_timeslot_evening',
          timeStart: '18:00',
          timeEnd: '23:59'
        },
        lateNight: {
          label: 'guide_calendar_timeslot_latenight',
          timeStart: '00:00',
          timeEnd: '05:59'
        }
      },
      isListView: false
    }
  },
  methods: {
    tabChange (name) {
      if (name === 'nowtv') {
        this.$router.push({ name: 'NowTv' })
      } else if (name === 'guide') {
        this.$router.push({ name: 'Guide' })
      } else if (name === 'radio') {
        this.$router.push({ name: 'RadioPlayer' })
      }
    },
    toggleView () {
      this.isListView = !this.isListView
    }
  }
}
</script>

<style scoped lang="scss">
    .container {
        width: 100%;
        max-width: 1920px;
        margin-left: auto;
        margin-right: auto;
    }
</style>



// WEBPACK FOOTER //
// src/containers/sections/Guide/_main.vue